module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/voicemod-white.68c88519.svg";